/**
 * @type {boolean}
 */
export const isDevMode = process.env.NODE_ENV !== 'production';

/**
 * Convert object to URL params.
 * @link https://dev.to/mornir/jqueryparam-in-vanilla-javascript-59mn
 * @param params
 * @return {string}
 */
export function objectToUrlParams(params = {}) {
    const result = new URLSearchParams(Object.entries(params));
    return result.toString();
}

// This is a simple helper to create a store inside the Vuex.
export function registerVuexStore(vuex, storeName, store) {
    if (!vuex) {
        return;
    }

    const isRegistered = vuex._modules.get([storeName]);

    if (!isRegistered) {
        vuex.registerModule(storeName, store);
    }
}

/**
 * @param element
 * @param to
 * @param duration
 */
export function scrollTo(element, to, duration) {
    if (duration <= 0) {
        return;
    }

    const difference = to - element.scrollTop;
    const perTick = difference / duration * 10;

    setTimeout(() => {
        element.scrollTop = element.scrollTop + perTick;

        if (element.scrollTop === to) {
            return;
        }

        scrollTo(element, to, duration - 10);
    }, 10);
}

/**
 * Minimalist template engine
 *
 * @example
 * template('Hello {{thing}}!', { thing: 'world' });
 *
 * @param {String} template - The template string
 * @param {Array|Object} data - Data to use in template
 * @returns {String}
 */
export function template(template, data) {
    for (let p in data) {
        template = template
            .replace(new RegExp('{{ '+ p +' }}', 'g'), data[p])
            .replace(new RegExp('{{'+ p +'}}', 'g'), data[p]);
    }

    return template;
}


/**
 * Author: Abhishek Dutta, 12 June 2020
 * License: CC0 (https://creativecommons.org/choose/zero/)
 * @return {string}
 */
export function uuid() {
    const temp_url = URL.createObjectURL(new Blob());
    const uuid = temp_url.toString();
    URL.revokeObjectURL(temp_url);
    // remove prefix (e.g. blob:null/, blob:www.test.com/, ...)
    return uuid.substr(uuid.lastIndexOf('/') + 1);
}
